import React from 'react'

import { string } from 'prop-types'

import CircledArrowRight from 'Pods/Shared/Icons/CircledArrowRight'
import ModelIcon from 'Pods/Shared/ModelIcon/ModelIcon'

function BudgetItem({ href, icon, title, count }) {
  return (
    <a href={href} className="categories-section__budget-item">
      <div className="categories-section__budget-item-content">
        <div className="categories-section__budget-item-icon-container">
          <ModelIcon icon={icon} width="24" height="24" />
        </div>
        <span className="categories-section__budget-item-title">{title}</span>
        <div className="categories-section__budget-item-count">{count}</div>
      </div>
      <div className="categories-section__budget-item-icon-wrapper">
        <CircledArrowRight width="24" height="24" />
      </div>
    </a>
  )
}

BudgetItem.propTypes = {
  href: string.isRequired,
  icon: string.isRequired,
  title: string.isRequired,
  count: string.isRequired,
}

export default BudgetItem
